import { Trans } from "@lingui/react/macro";
import { Box, Flex } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import CreateLocation from "@/features/locations/create-location/create-location";
import LocationsTable from "@/features/locations/locations-table/locations-table";
import { Can } from "@/shared/providers/casl-provider";

export const Route = createFileRoute("/_app/(multi-location)/admin/locations/")(
  {
    component: () => <LocationsPage />,
  },
);

function LocationsPage() {
  return (
    <Box p="lg">
      <Flex align="center" justify="space-between">
        <h1>
          <Trans>Lokasjoner</Trans>
        </h1>
        <Can I="create" a="Location">
          <CreateLocation />
        </Can>
      </Flex>

      <LocationsTable />
    </Box>
  );
}
